/**
 * @fileoverview A utility module for checking keyboard events.
 * @module getKey
 */

/**
 * Creates an object with properties to check for specific key presses in a keyboard event.
 *
 * @param {KeyboardEvent} event The keyboard event object.
 * @returns {{isTab: boolean, isShiftTab: boolean, isEscape: boolean}} An object with getter properties.
 */
export function getKey(event) {
  const { key } = event;
  const keyCode = event.code;
  const isShift = event.shiftKey;

  return {
    /**
     * Checks if the pressed key is the 'Tab' key without the 'Shift' key.
     * @type {boolean}
     */
    get isTab() {
      return !isShift && (key === 'Tab' || keyCode === 'Tab');
    },

    /**
     * Checks if the pressed key is a 'Shift + Tab' combination.
     * @type {boolean}
     */
    get isShiftTab() {
      return isShift && (key === 'Tab' || keyCode === 'Tab');
    },

    /**
     * Checks if the pressed key is the 'Escape' key.
     * @type {boolean}
     */
    get isEscape() {
      return key === 'Escape' || keyCode === 'Escape';
    },
  };
}
